import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, reactive, watch, onMounted } from 'vue'
    import { guid } from "@common/Guid"
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminCreatePipelinePage } from '@Integrations/Pipelines/pages-core'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AdminCreatePipelinePage',
  setup(__props) {

    document.title = "Create a pipeline"

    const tid = useOrganizationUnitId()

    const { useCurrentUserQuery, useCreatePipelineCommand, useConnectorProvidersQuery } = useAdminCreatePipelinePage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const connectorProvidersQuery = reactive(useConnectorProvidersQuery(true, false))
    const providers = computed(() => connectorProvidersQuery.model?.Providers || [])

    const { invoke, id, name, description, direction, timeTriggerRecurrency, validationErrors, succeed } = useCreatePipelineCommand(guid(), tid, userId)
    direction.value = 1
    timeTriggerRecurrency.value = null

    watch(succeed, () => {
        if (succeed.value) location.href = `/#/admin/integrations/pipelines/details/${tid}/${id.value}`
    })

    onMounted(() => {
        runCurrentUserQueryV1()
        connectorProvidersQuery.run()
    })

return { __sfc: true,tid, useCurrentUserQuery, useCreatePipelineCommand, useConnectorProvidersQuery, modelCurrentUserQueryV1, runCurrentUserQueryV1, userId, connectorProvidersQuery, providers, invoke, id, name, description, direction, timeTriggerRecurrency, validationErrors, succeed }
}

})